import React from 'react';

/**
 * Name + month filter bar shared by the KRA list pages (Team KRA, Cross
 * Inputs, Quarterly Dashboard, KRA Library). Purely presentational - each
 * page owns its own filter state and decides whether to filter locally or
 * send the month to the server. `showMonth` is off where a month doesn't
 * apply (templates aren't tied to one; the quarterly dashboard already has
 * its own quarter/year pickers).
 *
 * `month` is the <input type="month"> value ("YYYY-MM"), '' meaning every month.
 */
const KRAFilters = ({
  name,
  onNameChange,
  month = '',
  onMonthChange,
  showMonth = true,
  namePlaceholder = 'Search by name...',
  shown,
  total,
}) => {
  const isFiltered = name.trim() !== '' || (showMonth && month !== '');

  const clear = () => {
    onNameChange('');
    if (showMonth) onMonthChange('');
  };

  return (
    <div className="glass-card p-3 mb-4 flex flex-wrap items-end gap-3">
      <div className="flex-1 min-w-[180px]">
        <label className="block text-xs font-medium text-gray-700 mb-1">Name</label>
        <input
          type="search"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder={namePlaceholder}
          className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
        />
      </div>
      {showMonth && (
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Month</label>
          <input
            type="month"
            value={month}
            onChange={(e) => onMonthChange(e.target.value)}
            className="border border-gray-300 rounded px-3 py-2 text-sm"
          />
        </div>
      )}
      {isFiltered && (
        <button
          type="button"
          onClick={clear}
          className="px-3 py-2 text-sm rounded border border-gray-300 text-gray-700 font-semibold hover:bg-gray-50"
        >
          Clear
        </button>
      )}
      {total != null && (
        <span className="text-xs text-gray-500 ml-auto self-center">{shown} of {total}</span>
      )}
    </div>
  );
};

/** Case-insensitive substring match used by every page's name filter. */
export const matchesName = (value, query) => {
  const q = (query || '').trim().toLowerCase();
  return !q || (value || '').toLowerCase().includes(q);
};

export default KRAFilters;
